import React from 'react';
import { ListItem as StyledListItem} from './style';

const ListItem = ({item, fColor, bulletColor, hideList}) => {

  return (
    <StyledListItem
      hideList={hideList}
      fColor={fColor}
      bulletColor={bulletColor}
    >
      {item}
    </StyledListItem>
  );
}

export default ListItem;